<template>
	<IdleTracker v-if="$store.getters['session/isLogged']">
		<ChangeUserModal v-model="$store.state.layout.changeUserModalVisible"></ChangeUserModal>
		<div>
			<loading-anim :active="$store.state.loading" fullScreen toggleParentClass></loading-anim>
			<PrivateLayoutMenu :menuItems="allItems" :menuServiceItems="menuServiceItems"/>
			<PrivateLayoutMobileSubmenu v-if="!$uiHelpers.isDesktop" :menuItems="allItems" :menuServiceItems="menuServiceItems"></PrivateLayoutMobileSubmenu>
			<menu-banners/>
			<div class="pb-5 custom-container">
				<b-tabs fill v-if="showTabsMenu">
					<b-tab v-for="tab in menuItems.filter((item) => item.tab !== false)" :key="tab.path" :title="tab.title" :active="isTabActive(tab.path)" @click="onTabClick(tab)">
						<template v-slot:title>
							{{ tab.title }}
							<b-badge v-if="tab.bubble" variant="info">{{ tab.bubble }}</b-badge>
						</template>
					</b-tab>
				</b-tabs>
				<router-view :class="{ 'pt-5': $helpers.inIframe() }"></router-view>
				<!-- <b-row v-if="$route.meta.hideBackButton !== false && !!$route.meta.showTabMenu" class="pt-3">
					<BackButton goToParentRouteIfExists/>
				</b-row> -->
			</div>
		</div>
	</IdleTracker>
</template>

<script>
import layoutMixin from '@/mixins/layout.mixin'
import companyServicesMixin from '@/mixins/companyServices.mixin'
import i18nMixin from '@/mixins/i18n.mixin'
import gtagMixin from '@/mixins/gtag.mixin'
import { BTabs, BTab, BBadge } from 'bootstrap-vue'
import ChangeUserModal from '@/components/webapp/patient/ChangeUserModal'
import LoadingAnimVue from '../utils/LoadingAnim.vue'
import appHelpers from '@/helpers/app.helpers'
import MenuBanners from '@/components/webapp/patient/MenuBanners'
import accountRepository from '@/repositories/AccountRepository'
import PrivateLayoutMenu from '@/components/shared/PrivateLayoutMenu'
import PrivateLayoutMobileSubmenu from '@/components/shared/PrivateLayoutMobileSubmenu'
import { LOG_OFF, KICKOUT, APPOINTMENT_CANCELED } from '@/constants/signalRCommands'
import { getConsultationTitleById } from '@/constants/consultationTypes'
import { NEW_APPOINTMENT } from '../../constants/signalRCommands'
import { WELLWO_SERVICE, OPENSALUD_PRIME_SERVICE, REHANDREBODY_SERVICE } from '@/constants/patientServices'
import BackButton from '@/components/base/buttons/BackButton'
import IdleTracker from '@/components/utils/IdleTracker'

const I18N_FILE = 'private-layout'

export default {
	name: 'PrivateLayout',
  mixins: [i18nMixin(I18N_FILE), layoutMixin, gtagMixin, companyServicesMixin],
  components: {
		ChangeUserModal,
		BTabs,
		BTab,
		'loading-anim': LoadingAnimVue,
		MenuBanners,
		PrivateLayoutMenu,
		PrivateLayoutMobileSubmenu,
		BBadge,
		BackButton,
		IdleTracker
  },
  mounted () {
		this.$store.dispatch('signalr/init')
  },
	created () {
		this.$store.dispatch('layout/init')
	},
  methods: {
		isTabActive (path) {
			return this.$route.path.includes(path)
		}
	},
  computed: {
    menuItems () {
      if (this.$store.getters['session/userIsPatient']) {
        return [
			{
				title: this.$t('private-layout.my-profile-services'),
				path: 'profile',
				href: 'HomePaciente#/profile',
				tab: true,
				mainMenu: false
			},
			{
				title: this.$t('private-layout.health-data'),
				path: 'clinic-history',
				bubble: this.$store.getters['notifications/getUnreadFilesNumber']
			},
			{
				title: this.$t('private-layout.chats'),
				path: 'chats',
				bubble: this.$store.getters['notifications/getUnreadChatMessagesNumber']
			},
			{
				title: this.$t('private-layout.my-consultations'),
				path: 'appointments'
			},
			{
				title: this.$t('private-layout.my-agenda'),
				path: 'schedule',
				href: 'HomePaciente#/schedule'
			},
			{
				title: this.$t('private-layout.my-professionals'),
				path: 'professionals',
				href: 'HomePaciente#/doctors',
				mainMenu: true,
				tab: false
			},
			{
				title: this.$t('private-layout.search'),
				path: 'search'
			}
        ]
      } else if (this.$store.getters['session/userIsProfessional']) {
        return [
			{
				title: this.$t('private-layout.my-profile'),
				path: 'profile',
				href: '/HomeProfesional#/profile'
			},
			{
				title: this.$t('private-layout.my-services'),
				path: 'services',
				href: '/HomeProfesional#/services'
			},
			{
				title: this.$t('private-layout.chats-interconsultation'),
				path: 'chats',
				href: '/HomeProfesional#/chat'
			},
			{
				title: this.$t('private-layout.my-consultations'),
				path: 'appointments',
				href: '/HomeProfesional#/appointments'
			},
			{
				title: this.$t('private-layout.appointment-request'),
				path: 'requests',
				href: '/HomeProfesional#/requests'
			},
			{
				title: this.$t('private-layout.my-agenda'),
				path: 'schedule',
				href: '/HomeProfesional#/schedule'
			},
			{
				title: this.$t('private-layout.my-patients'),
				path: 'patients',
				href: '/HomeProfesional#/patients'
			}
        ]
      } else if (this.$store.getters['session/userIsCenter']) {
				return []
        /* return [
					{
						title: this.$t('private-layout.my-profile'),
						path: 'profile',
						href: '/HomeCentro#/profile'
					},
          {
            title: this.$t('private-layout.my-requests'),
						path: 'requests',
            href: '/HomeCentro#/appointments'
          },
          {
            title: this.$t('private-layout.my-consultations'),
						path: 'appointments',
            href: '/HomeCentro#/requests'
          },
          {
            title: this.$t('private-layout.my-professionals'),
						path: 'professionals',
            href: '/HomeCentro#/professionals'
          },
          {
            title: this.$t('private-layout.my-patients'),
						path: 'patients',
            href: '/HomeCentro#/patients'
          }
        ] */
      }
			return []
    },
		showTabsMenu () {
			return this.$route.meta && !!this.$route.meta.showTabMenu && this.menuItems && this.menuItems.length > 0
		},
		notTabMenuItems () {
			const _this = this
			return [
				{
					title: this.$t('private-layout.my-apps'),
					path: 'my-apps',
					action: () => {
						_this.$router.push('/patient/my-apps')
					},
					tab: false,
					mainMenu: false
				},
				{
					title: this.$t('private-layout.habits-challenges'),
					path: 'habits',
					action: () => {
						this.$router.push('/patient/goals-habits-menu')
					},
					tab: false,
					mainMenu: false
				},
				{
					title: this.$store.getters['session/healthyCommunityActive'] ? this.$t('private-layout.healthy-community') : this.$t('private-layout.patients-like-you'),
					action: () => {
						if (_this.$store.getters['session/healthyCommunityActive']) {
							_this.goToHealthyCommunity()
						} else {
							appHelpers.goToForum()
						}
					},
					tab: false,
					mainMenu: false
				},
				{
					title: this.$t('private-layout.evaluate-your-health'),
					action: () => {
						_this.$router.push('/patient/tests')
					},
					tab: false,
					mainMenu: false
				},
				{
					title: this.$t('private-layout.healthy-foods'),
					action: () => {
						_this.$router.push('/patient/foods')
					},
					tab: false,
					mainMenu: false
				}
			]
		},
		menuServiceItems () {
			const _this = this
			const items = [
				{
					title: 'opensaludWellness',
					action: () => {
						_this.goToWellwo()
					},
					active: this.$store.getters['session/userHasActiveCompanyService'](WELLWO_SERVICE)
				},
				{
					title: 'opensaludPass',
					action: () => {
						_this.goToOpensaludPrime(_this.$apiToken)
					},
					active: this.$store.getters['session/userHasActiveCompanyService'](OPENSALUD_PRIME_SERVICE)
				},
				{
					title: this.$t('private-layout.physiotherapy'),
					action: () => {
						_this.goToRehBody()
					},
					active: this.$store.getters['session/userHasActiveCompanyService'](REHANDREBODY_SERVICE)
				}
			]
			return items.filter(item => item.active)
		},
		allItems () {
			return [...this.menuItems, ...this.notTabMenuItems]
		}
  },
  watch: {
    '$store.state.signalr.commandReceived' ({ command, data }) {
			switch (command) {
				case LOG_OFF:
					this.logOff()
					break
				case KICKOUT:
					accountRepository.isntMultiUser().then(response => {
						if (response.data) this.$router.push('/cuenta/kickout')
					})
					break
				case APPOINTMENT_CANCELED:
				case NEW_APPOINTMENT:
					let dataSplitted = data.split(';')
					let profName = dataSplitted[0]
					let date = dataSplitted[1]
					let appointmentType = getConsultationTitleById(dataSplitted[2])
					let title = command === APPOINTMENT_CANCELED ? this.$t('notifications.hasCanceled') : this.$t('notifications.hasScheduled')
					this.$store.dispatch('showInfoAlert', this.$t('notifications.appointmentCanceledByProf', {profName, title, date, appointmentType}))
					break
			}
    }
  }
}
</script>

<style lang="scss" scoped>

.ctm-container {
    @include container-padding;
    h3 {
      color: black
    }
}

/deep/ .nav-item {
  margin-right: 0rem;
	font-weight: 600;

  @include media(mobile, tablets) {
    padding-right: 0;
    border: 0px !important;
  }
}

@include desktop {
	/deep/ .navbar-nav{
		margin-left: auto !important;
	}
}


/deep/ .navbar-brand {
  margin-right: 0;
}

.navbar {
	z-index: 1;
}

@include media(tablets, mobile) {
  /deep/ .navbar-nav{
    box-shadow: none !important;
    background-color: transparent !important;
    display: table;
  }
  .navbar {
    @include container-padding;
		/* @include mobile {
			padding: {
				top: 1rem;
				bottom: 1rem;
			}
		} */
		@include tablets {
			padding: {
				top: 2rem;
				bottom: 2rem;
			}
		}
    .btn-dropdown{
			padding: .7rem ;
    }
  }
}

.navbar-brand-img {
  @include media(desktop, desktop-xl) {
    width: 175px;
  }
  
  @include desktop-sm {
    width: 130px !important;
  }

  @include mobile {
    width: 140px !important;
  }
}

/deep/.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
/deep/.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

$transition-sidebar: .2s ease-in-out;
$transition-cubic-bezier: all 0.3s cubic-bezier(.25, .8, .25, 1);

hr {
	&:not(.divider){
		@include desktop {
			margin: {
				top: 1rem;
				bottom: 1rem;
			}
		}

		@include media(tablets, mobile) {
			margin: .75rem 0;
		}
	}
}

.divider {
  background-color: $white;
  height: 2px;
	width: 100%;
	margin: 2rem 0;

	@include media(tablets, mobile) {
		margin: 1.5rem 0;
	}
}


p {
  color: $blue;

  @include desktop {
    &:is(:last-child) {
      margin-right: 1rem;
    }&:is(:first-child) {
      margin-left: 1rem;
    }
  }
}

.custom-container {
	@include container-padding-private;
	.custom-container {
		transition: all 0.3s ease;
	}

	@include desktop {
		min-height: 60dvh;
	}

	@include desktop-xl {
		min-height: 70dvh;
	}
}

/deep/ .nav-tabs {
	@include media(tablets, mobile) {
		display: none;
	}
}

.generic-back-btn {
	position: inherit;
	bottom: 24px;
	left: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/PrivateLayout.vue